const blocksSettings = {
  service: {
    color: "bg-yellow-100",
    border: "border border-black",
    blocks: {
      name: true,
      title: true,
      dependencies: true,
      image: false,
      description: true,
      hidden: true,
      pdfOptions: false,
    },
  },
  step: {
    color: "bg-white-100",
    border: "border border-black",
    blocks: {
      name: true,
      title: true,
      dependencies: true,
      image: true,
      description: true,
      hidden: true,
      pdfOptions: false,
    },
  },
  recursive_question: {
    color: "bg-kkgreen-400",
    blocks: {
      name: true,
      title: true,
      dependencies: true,
      image: true,
      description: true,
      hidden: true,
      pdfOptions: false,
    },
  },
  output: {
    color: "bg-gray-300",
    blocks: {
      name: true,
      title: true,
      dependencies: true,
      image: true,
      description: true,
      outputType: true,
      hidden: true,
      pdfOptions: true,
    },
  },
  question: {
    color: "bg-blue-100",
    blocks: {
      name: true,
      dependencies: true,
      image: true,
      description: true,
      title: true,
      input: true,
      required: true,
      hidden: true,
      pdfOptions: false,
    },
  },
  option: {
    color: "bg-blue-100",
    blocks: {
      name: true,
      description: true,
      title: true,
      image: true,
      dependencies: true,
      option_value: true,
      product: true,
      system: true,
      hidden: true,
      pdfOptions: false,
    },
  },
  alert: {
    color: "bg-pink-200",
    blocks: {
      name: true,
      dependencies: true,
      image: true,
      description: true,
      title: true,
      alertType: true,
      hidden: true,
      pdfOptions: false,
    },
  },
};

export default blocksSettings;
